__turbopack_context__.v({
  "aiSearchTextButton": "EoGlCW_aiSearchTextButton",
  "desktopContainer": "EoGlCW_desktopContainer",
  "desktopContainerWrapper": "EoGlCW_desktopContainerWrapper",
  "iconButton": "EoGlCW_iconButton",
  "loadingIconButton": "EoGlCW_loadingIconButton",
  "mobileContainer": "EoGlCW_mobileContainer",
  "mobileContentWrapper": "EoGlCW_mobileContentWrapper",
  "opacityAnimation": "EoGlCW_opacityAnimation",
  "startAdornmentContainer": "EoGlCW_startAdornmentContainer",
});
